import { render, staticRenderFns } from "./ATab.vue?vue&type=template&id=025f095a"
import script from "./ATab.vue?vue&type=script&lang=js"
export * from "./ATab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports